<template>
  <a-input v-model="floor" v-bind="$attrs" size="large" allow-clear>
    <a-icon slot="prefix" type="idcard" style="color: rgba(0,0,0,.25)" />
  </a-input>
</template>

<script>
export default {
  name: 'Identification',
  props: ['value'],
  computed: {
    floor: {
      get() {
        return this.value
      },
      set(value) {
        if (/^\d+$/.test(value)) {
          this.$emit('input', value)
          this.$emit('change', value)
        } else {
          this.$emit('input', null)
          this.$emit('change', null)
        }
      }
    },
  },
}
</script>
